import { Button as ButtonStyled } from "./styles";

// Cast to fix React 17 + @types/react 18 compatibility issue
const Button = ButtonStyled as any;

type Props = {
  title: string;
  url: string;
  blank: boolean;
};

const ExternalLink: React.FC<Props> = (props) => {
  const { url, title, blank } = props;
  return (
    <Button href={url} target={`${blank ? "_blank" : ""}`}>
      {title}
    </Button>
  );
};

export default ExternalLink;
